{
  "user": {
    "form": {
      "addTitle": "Buat Pengguna",
      "editTitle": "Sunting Pengguna",
      "fields": {
        "username": "Nama Pengguna",
        "email": "Surel",
        "fullName": "Nama Lengkap",
        "password": "Kata Sandi",
        "confirmPassword": "Konfirmasi Kata Sandi",
        "facility": "Fasilitas",
        "roles": "Peran",
        "active": "Aktif",
        "allFacilities": "Semua fasilitas (seluruh sistem kesehatan)",
        "globalAccessAck": "Saya memahami bahwa ini memberikan akses ke semua fasilitas",
        "departments": "Departemen",
        "primaryDepartment": "Utama",
        "roleFacility": "Fasilitas untuk {{role}}",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ fasilitas lain",
        "removeFacilityFromRole": "hapus satu",
        "otherRoles": "Lainnya"
      },
      "errors": {
        "usernameMin": "Nama pengguna minimal {{min}} karakter",
        "emailInvalid": "Alamat surel tidak valid",
        "passwordMin": "Kata sandi minimal {{min}} karakter",
        "confirmPasswordRequired": "Mohon konfirmasi kata sandi",
        "passwordMismatch": "Kata sandi tidak cocok",
        "rolesRequired": "Minimal satu peran harus dipilih",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "Konfirmasikan pemberian akses seluruh sistem kesehatan sebelum menyimpan."
      },
      "submit": {
        "create": "Buat Pengguna",
        "update": "Perbarui Pengguna"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Pengguna berhasil dibuat",
        "updatedSuccess": "Pengguna berhasil diperbarui",
        "saveError": "Gagal menyimpan pengguna",
        "departmentsSaveError": "Pengguna tersimpan, tetapi penetapan departemen gagal. Edit pengguna untuk mencoba lagi."
      },
      "globalAccessWarning": "Ini memberikan akses ke pasien di SEMUA fasilitas, bukan sekadar jangkauan panggilan. Gunakan hanya untuk staf yang benar-benar mencakup seluruh sistem kesehatan, seperti petugas jaga.",
      "departmentsHint": "Tempat akun ini bekerja. Ini hanya konteks dan atribusi — tidak memberikan akses ke pasien mana pun.",
      "noDepartments": "Belum ada departemen yang dikonfigurasi."
    },
    "list": {
      "title": "Manajemen Pengguna",
      "subtitle": "Kelola pengguna sistem, peran, dan akses",
      "columns": {
        "username": "Nama Pengguna",
        "fullName": "Nama Lengkap",
        "email": "Email",
        "roles": "Peran",
        "facility": "Fasilitas",
        "status": "Status",
        "lastLogin": "Login Terakhir",
        "actions": "Aksi",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "Cari pengguna...",
        "allRoles": "Semua Peran",
        "allFacilities": "Semua Fasilitas",
        "allStatus": "Semua Status",
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      },
      "actions": {
        "new": "Buat Pengguna",
        "editTitle": "Edit pengguna",
        "resetPasswordTitle": "Atur ulang kata sandi",
        "activate": "Aktifkan",
        "deactivate": "Nonaktifkan",
        "activateAria": "Aktifkan pengguna",
        "deactivateAria": "Nonaktifkan pengguna"
      },
      "lastLoginNever": "Tidak Pernah",
      "empty": "Tidak ada pengguna yang cocok dengan filter Anda",
      "pagination": {
        "summary": "Menampilkan {{from}}-{{to}} dari {{total}}"
      },
      "toast": {
        "activated": "Pengguna {{username}} diaktifkan",
        "deactivated": "Pengguna {{username}} dinonaktifkan",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "Semua fasilitas",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "locked": "Terkunci",
      "pendingActivation": "Menunggu Aktivasi"
    },
    "mfaStatus": {
      "enrolled": "Terdaftar",
      "notEnrolled": "Tidak Terdaftar",
      "exempt": "Dikecualikan"
    }
  },
  "role": {
    "form": {
      "addTitle": "Buat Peran",
      "editTitle": "Sunting Peran",
      "fields": {
        "name": "Nama Peran",
        "code": "Kode Peran",
        "description": "Deskripsi",
        "category": "Kategori",
        "parentRole": "Peran Induk (mewarisi izin)"
      },
      "options": {
        "none": "Tidak Ada"
      },
      "errors": {
        "nameRequired": "Nama peran wajib diisi",
        "codeRequired": "Kode peran wajib diisi"
      },
      "submit": {
        "create": "Buat Peran",
        "update": "Perbarui Peran"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Peran berhasil dibuat",
        "updatedSuccess": "Peran berhasil diperbarui",
        "saveError": "Gagal menyimpan peran"
      }
    },
    
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "source": {
      "own": "Sendiri",
      "inherited": "Diwariskan",
      "category": "Kategori"
    },
    "permissions": {
      "ownTitle": "Sunting Izin",
      "deniedTitle": "Sunting Izin yang Ditolak",
      "ownSubtitle": "{{granted}} dari {{total}} diberikan. Izin warisan dan default kategori ditampilkan di Matriks Akses; halaman ini hanya mengelola pemberian peran itu sendiri.",
      "deniedSubtitle": "Izin yang ditolak menggantikan pemberian dari izin peran itu sendiri, peran induknya, dan default kategorinya. Centang izin untuk menolaknya secara eksplisit bagi peran ini.",
      "invalidRoleId": "ID peran tidak valid.",
      "save": "Simpan Izin",
      "saveDenied": "Simpan Izin yang Ditolak",
      "cancel": "Batal",
      "toast": {
        "updatedSuccess": "Izin berhasil diperbarui",
        "deniedUpdatedSuccess": "Izin yang ditolak berhasil diperbarui",
        "saveError": "Gagal menyimpan izin",
        "saveDeniedError": "Gagal menyimpan izin yang ditolak"
      },
      "permissionGroup": {
        "analytics": "Analitik",
        "audit": "Audit",
        "billing": "Penagihan",
        "bloodProduct": "Produk Darah",
        "consent": "Persetujuan",
        "dietOrder": "Order Diet",
        "discharge": "Pulang",
        "documentation": "Dokumentasi",
        "encounter": "Kunjungan",
        "infection": "Pengendalian Infeksi",
        "licensing": "Lisensi",
        "medication": "Obat",
        "notification": "Notifikasi",
        "order": "Order",
        "patient": "Pasien",
        "referral": "Rujukan",
        "research": "Penelitian",
        "restraint": "Restrain",
        "result": "Hasil",
        "scheduling": "Penjadwalan",
        "system": "Sistem",
        "transfer": "Pindah",
        "user": "Pengguna",
        "schedule": "Jadwal",
        "admin": "Administrasi",
        "report": "Laporan",
        "other": "Lainnya"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "Buat Kategori",
      "editTitle": "Edit Kategori",
      "fields": {
        "name": "Nama Kategori",
        "code": "Kode Kategori",
        "description": "Deskripsi",
        "sessionTimeout": "Batas Waktu Sesi (menit)",
        "maxFailedLogins": "Maks. Login Gagal",
        "mfaRequired": "Wajibkan MFA untuk kategori ini"
      },
      "placeholders": {
        "code": "mis. CLINICAL"
      },
      "errors": {
        "nameRequired": "Nama kategori diperlukan",
        "codeRequired": "Kode kategori diperlukan"
      },
      "submit": {
        "create": "Buat Kategori",
        "update": "Perbarui Kategori"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Kategori dibuat",
        "updatedSuccess": "Kategori diperbarui",
        "saveError": "Gagal menyimpan kategori"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "Tidak Ada",
      "basic": "Dasar",
      "full": "Penuh",
      "paranoid": "Sangat Ketat"
    },
    "permissions": {
      "title": "Izin Default",
      "titleWithName": "Izin Default — {{name}}",
      "subtitle": "Peran dalam kategori ini mewarisi izin ini kecuali ditolak secara eksplisit.",
      "invalidCategoryId": "ID kategori tidak valid.",
      "save": "Simpan Izin Default",
      "cancel": "Batal",
      "toast": {
        "updatedSuccess": "Izin default diperbarui",
        "saveError": "Gagal menyimpan izin default"
      }
    }
  },
  "permission": {
    "action": {
      "view": "Lihat",
      "viewSelf": "Lihat Milik Sendiri",
      "viewRestricted": "Lihat Terbatas",
      "read": "Baca",
      "write": "Tulis",
      "create": "Buat",
      "update": "Perbarui",
      "modify": "Ubah",
      "delete": "Hapus",
      "merge": "Gabung",
      "discharge": "Pulang",
      "transfer": "Pindah",
      "approve": "Setujui",
      "cosign": "Tanda Tangan Bersama",
      "sign": "Tanda Tangan",
      "plan": "Rencana",
      "manage": "Kelola",
      "all": "Semua",
      "breakGlass": "Akses Darurat",
      "export": "Ekspor",
      "amend": "Amandemen",
      "administer": "Berikan",
      "doubleCheck": "Pemeriksaan Ganda",
      "reconcile": "Rekonsiliasi",
      "verbalVerify": "Verifikasi Order Lisan",
      "verify": "Verifikasi",
      "acknowledge": "Konfirmasi",
      "prescribe": "Resepkan",
      "dispense": "Salurkan",
      "cancel": "Batal",
      "users": "Pengguna",
      "roles": "Peran",
      "facilities": "Fasilitas",
      "system": "Sistem",
      "audit": "Log Audit"
    }
  },
  "access": {
    "title": "Matriks Hak Akses",
    "subtitle": "Grid peran × izin",
    "searchPermission": "Cari izin…",
    "searchRole": "Cari peran…",
    "categoryFilter": "Kategori",
    "legend": {
      "own": "Sendiri",
      "inherited": "Diwarisi",
      "category": "Kategori",
      "denied": "Ditolak",
      "none": "Tidak ada"
    },
    "cellTooltip": {
      "hasOwn": "Diberikan langsung",
      "hasInherited": "Diwarisi dari peran induk: {{source}}",
      "hasCategory": "Diberikan melalui kategori: {{source}}",
      "denied": "Ditolak secara eksplisit",
      "none": "Tidak diberikan"
    },
    "inheritedFrom": "Diwarisi dari {{source}}",
    "bulkEdit": {
      "title": "Edit Massal",
      "applyTo": "Terapkan ke yang dipilih",
      "selectedPermissions": "{{count}} izin",
      "selectedRoles": "{{count}} peran",
      "actionGrant": "Berikan",
      "actionDeny": "Tolak",
      "actionClear": "Hapus",
      "save": "Simpan perubahan",
      "cancel": "Batal"
    },
    "emptyRoles": "Tidak ada peran yang cocok dengan filter.",
    "emptyPermissions": "Tidak ada izin yang cocok dengan filter.",
    "loading": "Memuat matriks hak akses…",
    "permissionColumn": "Izin",
    "rolePicker": {
      "trigger": "Pilih peran untuk dibandingkan",
      "filterPlaceholder": "Filter peran…",
      "empty": "Tidak ada peran yang cocok.",
      "groupAll": "Semua",
      "groupNone": "Tidak ada",
      "footerSummary": "{{count}} dari {{total}} dipilih",
      "selectAll": "Pilih semua",
      "clear": "Bersihkan"
    },
    "empty": {
      "selectRolesPrompt": "Pilih setidaknya satu peran untuk dibandingkan.",
      "selectAllRoles": "Pilih semua peran",
      "noPermissions": "Tidak ada izin yang ditemukan."
    },
    "legendCategoryDefault": "Bawaan Kategori",
    "legendNotGranted": "Tidak Diberikan",
    "page": {
      "title": "Matriks Hak Akses",
      "subtitle": "Lihat dan kelola peran, izin, dan kebijakan akses"
    },
    "tabs": {
      "matrix": "Matriks Hak Akses",
      "roles": "Manajemen Peran",
      "categories": "Manajemen Kategori"
    },
    "roles": {
      "searchPlaceholder": "Cari peran atau izin...",
      "createButton": "Buat Peran",
      "columns": {
        "role": "Peran",
        "category": "Kategori",
        "parent": "Peran Induk",
        "permissions": "Izin",
        "users": "Pengguna",
        "actions": "Aksi"
      },
      "systemBadge": "Sistem",
      "managePermissionsTitle": "Kelola izin",
      "manageDeniedTitle": "Kelola izin yang ditolak",
      "deniedBadge": "Ditolak",
      "editTitle": "Edit peran",
      "deleteTitle": "Hapus peran",
      "expandAria": "Perluas peran",
      "collapseAria": "Ciutkan peran",
      "effectivePermissions": "Izin Efektif",
      "noPermissionsAssigned": "Tidak ada izin yang diberikan.",
      "empty": "Peran tidak ditemukan.",
      "delete": {
        "title": "Hapus Peran",
        "description": "Apakah Anda yakin ingin menghapus peran \"{{name}}\"? Tindakan ini tidak dapat dibatalkan.",
        "confirm": "Hapus"
      },
      "toast": {
        "deleted": "Peran dihapus",
        "deleteError": "Gagal menghapus peran"
      }
    },
    "categories": {
      "subtitle": "Kategori mengelompokkan peran dan menetapkan kebijakan bersama (MFA, batas sesi).",
      "createButton": "Buat Kategori",
      "requireMfa": "Wajib MFA",
      "yes": "Ya",
      "no": "Tidak",
      "sessionTimeout": "Batas Waktu Sesi",
      "sessionTimeoutMinutes": "{{count}} mnt",
      "maxFailedLogins": "Maks Login Gagal",
      "manageDefaults": "Kelola Izin Bawaan",
      "editTitle": "Edit",
      "editAria": "Edit kategori",
      "deleteTitle": "Hapus",
      "deleteAria": "Hapus kategori",
      "empty": "Belum ada kategori yang ditentukan.",
      "delete": {
        "title": "Hapus Kategori",
        "description": "Apakah Anda yakin ingin menghapus kategori \"{{name}}\"? Tindakan ini tidak dapat dibatalkan.",
        "confirm": "Hapus"
      },
      "toast": {
        "deleted": "Kategori dihapus",
        "deleteError": "Gagal menghapus kategori"
      }
    },
    "confirm": {
      "bulkApply": "Terapkan {{count}} perubahan ke {{roleCount}} peran?",
      "discardChanges": "Buang perubahan yang belum disimpan?"
    },
    "popover": {
      "grantTitle": "Berikan izin",
      "denyTitle": "Tolak izin",
      "clearTitle": "Hapus izin",
      "grantNote": "Memberikan izin ini akan menggantikan penolakan yang diwarisi.",
      "denyNote": "Menolak izin ini akan menggantikan pemberian yang diwarisi.",
      "clearNote": "Menghapus akan mengembalikan ke perilaku yang diwarisi."
    },
    "toast": {
      "permissionGranted": "Izin diberikan",
      "permissionDenied": "Izin ditolak",
      "permissionCleared": "Izin dihapus",
      "bulkApplied": "Perubahan massal diterapkan",
      "saveError": "Gagal menyimpan perubahan"
    }
  },
  "confirm": {
    "restartIntegration": "Mulai ulang \"{{name}}\"? Koneksi aktif akan terputus sebentar saat materi TLS baru dimuat.",
    "revokeFhirEndpoint": "Cabut \"{{name}}\"? Panggilan keluar ke endpoint ini akan berhenti.",
    "rotateSmartSecret": "Putar client secret untuk \"{{name}}\"? Secret lama akan langsung berhenti berfungsi.",
    "revokeSmartApp": "Cabut \"{{name}}\"? Permintaan token mendatang dari aplikasi ini akan gagal.",
    "deactivateThirdPartyApp": "Nonaktifkan \"{{name}}\"?"
  },
  "toast": {
    "tierCreated": "Tingkat dibuat",
    "tierCloned": "Tingkat diklon",
    "tierDeleted": "Tingkat dihapus",
    "tierStatusUpdated": "Status diperbarui",
    "tierFeaturesUpdated": "Fitur diperbarui",
    "tierLimitsUpdated": "Batas diperbarui",
    "tierSaveError": "Gagal membuat tingkat",
    "tierValidation": "Nama dan kode wajib diisi",
    "licenseKeyGenerated": "Kunci lisensi dibuat",
    "licenseKeyCopied": "Kunci lisensi dibuat dan disalin ke papan klip",
    "overridesSaved": "Penggantian disimpan",
    "pricingConfigSaved": "Konfigurasi disimpan",
    "pricingPriceUpdated": "Harga diperbarui",
    "pricingRuleCreated": "Aturan harga dibuat",
    "addonUpdated": "Modul tambahan diperbarui",
    "invalidNumber": "Masukkan angka yang valid",
    "csvExported": "Mengekspor {{filename}}",
    "integrationUpdated": "Integrasi diperbarui",
    "integrationAdded": "Integrasi ditambahkan",
    "integrationInvalidConfig": "Konfigurasi tidak valid — periksa host/port dan kolom TLS",
    "integrationDuplicateName": "Integrasi dengan nama tersebut sudah ada",
    "integrationSaveFailed": "Gagal menyimpan integrasi",
    "smartAppRegistered": "Aplikasi SMART terdaftar",
    "smartAppRegisterFailed": "Gagal mendaftarkan aplikasi SMART",
    "smartAppUpdated": "Aplikasi SMART diperbarui",
    "smartAppUpdateFailed": "Gagal memperbarui aplikasi SMART",
    "fhirEndpointUpdated": "Endpoint diperbarui",
    "fhirEndpointRegistered": "Endpoint terdaftar",
    "fhirEndpointInvalidConfig": "Konfigurasi tidak valid — periksa base URL dan kolom auth",
    "fhirEndpointDuplicateName": "Endpoint dengan nama itu sudah ada",
    "fhirEndpointSaveFailed": "Gagal menyimpan endpoint",
    "clientIdCopied": "Client ID disalin",
    "clientSecretCopied": "Client secret disalin",
    "statusRefreshed": "Status disegarkan",
    "connTestOk": "Uji koneksi berhasil",
    "connTestFailed": "Uji koneksi gagal - periksa konfigurasi endpoint",
    "serverRestarted": "Server dimulai ulang — material TLS baru berlaku",
    "clientReconnected": "Klien terhubung kembali — material TLS baru berlaku",
    "notRunning": "Tidak berjalan — mulai server/klien untuk menerapkan konfigurasi",
    "restartFailed": "Gagal memulai ulang integrasi",
    "metadataOk": "/metadata OK{{detail}}",
    "metadataFailed": "/metadata gagal: {{error}}",
    "metadataProbeFailed": "Gagal memeriksa /metadata",
    "metadataUnknownError": "tidak diketahui",
    "fhirRevoked": "Endpoint FHIR dicabut",
    "fhirRevokeFailed": "Gagal mencabut endpoint",
    "smartRevoked": "Aplikasi SMART dicabut",
    "smartRevokeFailed": "Gagal mencabut aplikasi SMART",
    "secretRotated": "Rahasia klien dirotasi",
    "rotateSecretFailed": "Gagal merotasi rahasia",
    "messageRequeued": "Pesan diantrekan ulang untuk dicoba lagi",
    "messageRetryFailed": "Coba lagi gagal",
    "messageSkipped": "Pesan dilewati — antrean akan berlanjut",
    "messageSkipFailed": "Melewati gagal",
    "messageAbandoned": "Pesan ditinggalkan",
    "messageAbandonFailed": "Meninggalkan gagal",
    "messageResent": "Pesan dikirim ulang sebagai baru",
    "messageResendFailed": "Kirim ulang gagal",
    "reasonRequired": "Alasan wajib diisi",
    "copiedToClipboard": "Disalin ke papan klip",
    "thirdPartyAppCreated": "Aplikasi pihak ketiga berhasil dibuat",
    "thirdPartyAppUpdated": "Aplikasi pihak ketiga berhasil diperbarui",
    "thirdPartyAppDeactivated": "Aplikasi pihak ketiga dinonaktifkan",
    "thirdPartyAppLaunchUrl": "URL peluncuran dibuat: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "Tambah Fasilitas",
      "editTitle": "Sunting Fasilitas",
      "fields": {
        "name": "Nama",
        "code": "Kode",
        "type": "Jenis",
        "address": "Alamat",
        "city": "Kota",
        "stateProvince": "Provinsi/Negara Bagian",
        "country": "Negara",
        "phone": "Telepon",
        "timeZone": "Zona Waktu",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "Contoh: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "Nama zona waktu IANA (contoh: Asia/Singapore). Digunakan untuk tanggal lokal fasilitas dalam sensus pasien, MAR, dan laporan."
      },
      "options": {
        "otherIana": "Lainnya (IANA)…",
        "useCuratedList": "Gunakan daftar pilihan"
      },
      "errors": {
        "nameMin": "Nama fasilitas minimal {{min}} karakter",
        "codeFormat": "Kode hanya boleh berisi huruf kapital dan angka",
        "typeRequired": "Jenis fasilitas wajib diisi",
        "countryRequired": "Negara wajib diisi",
        "timeZoneRequired": "Zona waktu wajib diisi",
        "timeZoneInvalidIana": "Peladen menolak zona waktu ini. Mohon gunakan nama IANA yang valid (contoh: Asia/Singapore).",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "Buat",
        "update": "Perbarui"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Fasilitas berhasil dibuat",
        "updatedSuccess": "Fasilitas berhasil diperbarui",
        "saveError": "Gagal menyimpan fasilitas",
        "invalidTimeZone": "Permintaan tidak valid — mohon periksa apakah zona waktu adalah nama IANA yang valid (contoh: Asia/Singapore)."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "Manajemen Fasilitas",
      "subtitle": "Fasilitas, departemen, dan (melalui pohon ini) sekilas hierarki lokasi fisik. Untuk pohon lokasi lengkap (gedung → lantai → unit → ruangan → ranjang), lihat <locationsLink>Lokasi</locationsLink>.",
      "columns": {
        "name": "Nama",
        "code": "Kode",
        "type": "Tipe",
        "address": "Alamat",
        "phone": "Telepon",
        "depts": "Dept.",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari fasilitas..."
      },
      "actions": {
        "new": "Tambah Fasilitas",
        "editTitle": "Ubah"
      },
      "expand": {
        "expand": "Bentangkan fasilitas",
        "collapse": "Tutup fasilitas"
      },
      "empty": {
        "noMatch": "Tidak ada fasilitas yang cocok dengan pencarian itu.",
        "none": "Belum ada fasilitas — klik Tambah Fasilitas untuk memulai."
      },
      "departments": {
        "title": "Departemen",
        "add": "Tambah Departemen",
        "empty": "Tidak ada departemen yang dikonfigurasi",
        "locationsCount": "{{count}} lokasi",
        "editTitle": "Ubah departemen"
      },
      "locations": {
        "title": "Lokasi",
        "add": "Tambah",
        "empty": "Tidak ada lokasi di departemen ini. Pohon lokasi (gedung → lantai → unit → ranjang) dikelola di <locationsLink>Lokasi</locationsLink>."
      }
    },
    "type": {
      "generalHospital": "Rumah Sakit Umum",
      "teachingHospital": "Rumah Sakit Pendidikan",
      "specialtyHospital": "Rumah Sakit Khusus",
      "communityHospital": "Rumah Sakit Masyarakat",
      "clinic": "Klinik"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "Tambah Sistem Kesehatan",
      "editTitle": "Ubah Sistem Kesehatan",
      "subtitle": "Tingkat teratas dalam struktur organisasi. Induk dari satu atau lebih fasilitas.",
      "sections": {
        "identity": "Identitas",
        "primaryContact": "Kontak utama",
        "address": "Alamat"
      },
      "fields": {
        "code": "Kode",
        "name": "Nama",
        "taxId": "NPWP",
        "contactName": "Nama",
        "contactEmail": "Email",
        "contactPhone": "Telepon",
        "addressLine1": "Alamat baris 1",
        "addressLine2": "Alamat baris 2",
        "city": "Kota",
        "stateProvince": "Provinsi",
        "postalCode": "Kode pos",
        "country": "Negara",
        "active": "Aktif — hapus centang untuk menonaktifkan."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "Kode tidak dapat diubah setelah dibuat."
      },
      "errors": {
        "codeRequired": "Kode harus diisi",
        "nameRequired": "Nama harus diisi"
      },
      "submit": {
        "create": "Buat Sistem Kesehatan",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Sistem kesehatan berhasil dibuat",
        "updatedSuccess": "Sistem kesehatan berhasil diperbarui",
        "saveError": "Gagal menyimpan sistem kesehatan",
        "codeConflict": "Kode sistem sudah digunakan",
        "invalidData": "Data sistem kesehatan tidak valid"
      }
    },
    "list": {
      "title": "Sistem Kesehatan",
      "subtitle": "Puncak pohon organisasi — perusahaan / sistem kesehatan induk yang memiliki satu atau lebih fasilitas. Jarang diubah setelah penyiapan awal.",
      "columns": {
        "name": "Nama",
        "code": "Kode",
        "contact": "Kontak",
        "location": "Lokasi",
        "facilities": "Fasilitas",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari berdasarkan nama atau kode..."
      },
      "actions": {
        "new": "Tambah Sistem Kesehatan",
        "editTitle": "Ubah"
      },
      "status": {
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      },
      "empty": {
        "noMatch": "Tidak ada sistem kesehatan yang cocok dengan pencarian itu.",
        "none": "Belum ada sistem kesehatan — klik Tambah Sistem Kesehatan untuk memulai."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "Tambah Lokasi",
      "editTitle": "Edit Lokasi",
      "subtitle": "Lokasi fisik — gedung, lantai, unit, ruangan, atau tempat tidur. Kompatibel FHIR R4 Location. Bersarang melalui lokasi induk untuk membangun pohon hierarki.",
      "sections": {
        "hierarchy": "Hierarki",
        "identity": "Identitas",
        "classification": "Klasifikasi",
        "physicalAttributes": "Atribut fisik"
      },
      "fields": {
        "facility": "Fasilitas",
        "parentLocation": "Lokasi induk",
        "department": "Departemen (opsional)",
        "code": "Kode",
        "abbreviation": "Singkatan",
        "name": "Nama",
        "physicalType": "Tipe fisik (FHIR)",
        "clinicalType": "Tipe klinis",
        "status": "Status (FHIR)",
        "operationalStatus": "Status operasional (HL7 0116)",
        "building": "Gedung",
        "floor": "Lantai",
        "wing": "Sayap",
        "roomNumber": "Nomor kamar",
        "bedIdentifier": "Pengenal tempat tidur",
        "capacity": "Kapasitas",
        "active": "Aktif (flag lama)"
      },
      "placeholders": {
        "facility": "Pilih fasilitas…",
        "parentNone": "Tidak ada (tingkat atas)",
        "departmentNone": "Tidak ada",
        "code": "4W-12-A",
        "name": "4W-12 Tempat Tidur A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "Set nilai FHIR LocationPhysicalType.",
        "clinicalType": "Lama; hapus saat service_type tiba."
      },
      "physicalAttributes": {
        "show": "Tampilkan ▾",
        "hide": "Sembunyikan ▴"
      },
      "errors": {
        "facilityRequired": "Fasilitas harus diisi",
        "codeRequired": "Kode harus diisi",
        "nameRequired": "Nama harus diisi"
      },
      "submit": {
        "create": "Buat Lokasi",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Lokasi berhasil dibuat",
        "updatedSuccess": "Lokasi berhasil diperbarui",
        "saveError": "Gagal menyimpan lokasi",
        "codeConflict": "Kode lokasi sudah digunakan",
        "invalidData": "Data lokasi tidak valid"
      }
    },
    "list": {
      "title": "Hierarki Lokasi",
      "subtitle": "Pohon fisik: gedung → lantai → unit → ruang → tempat tidur. Selaras dengan FHIR LocationPhysicalType. Klik lencana status tempat tidur untuk menggilir okupansi. Fasilitas dan departemen dikelola di <facilitiesLink>Fasilitas</facilitiesLink>.",
      "filter": {
        "search": "Cari berdasarkan nama atau kode...",
        "allFacilities": "Semua fasilitas"
      },
      "actions": {
        "new": "Tambah Lokasi",
        "addChildTitle": "Tambah anak",
        "editTitle": "Edit"
      },
      "expand": {
        "expand": "Perluas lokasi",
        "collapse": "Ciutkan lokasi"
      },
      "bed": {
        "toggleTitle": "Klik untuk beralih ke {{next}}"
      },
      "empty": {
        "noMatch": "Tidak ada lokasi yang cocok dengan pencarian itu.",
        "none": "Belum ada lokasi di fasilitas ini."
      },
      "toast": {
        "bedStatusUpdated": "Status tempat tidur diperbarui",
        "bedStatusError": "Gagal memperbarui status tempat tidur"
      }
    },
    "type": {
      "si": "Situs",
      "bu": "Gedung",
      "wi": "Sayap",
      "wa": "Bangsal",
      "lvl": "Lantai",
      "co": "Koridor",
      "ro": "Ruang",
      "bd": "Tempat Tidur",
      "ve": "Virtual",
      "ho": "Rumah",
      "ca": "Lemari",
      "rd": "Jalan",
      "area": "Area",
      "jdn": "Yurisdiksi"
    },
    "clinicalType": {
      "examRoom": "Ruang periksa",
      "inpatientBed": "Tempat tidur rawat inap",
      "procedureRoom": "Ruang tindakan",
      "icu": "ICU",
      "ed": "IGD",
      "or": "Ruang operasi",
      "virtual": "Virtual"
    },
    "status": {
      "active": "Aktif",
      "suspended": "Ditangguhkan",
      "inactive": "Nonaktif",
      "op": {
        "O": "Terisi",
        "U": "Kosong",
        "H": "Pembersihan",
        "K": "Terkontaminasi",
        "I": "Isolasi",
        "C": "Ditutup"
      }
    },
    "capability": {
      "isolation": "Mampu isolasi",
      "negativePressure": "Tekanan negatif",
      "bariatric": "Mampu bariatrik",
      "telemetry": "Mampu telemetri",
      "icu": "Tingkat ICU"
    }
  },
  "department": {
    "form": {
      "addTitle": "Tambah Departemen",
      "editTitle": "Edit Departemen",
      "subtitle": "Unit organisasi di dalam fasilitas. Dapat bertingkat (mis., Kardiologi → Lab EP) melalui departemen induk.",
      "sections": {
        "department": "Departemen"
      },
      "fields": {
        "facility": "Fasilitas",
        "code": "Kode",
        "abbreviation": "Singkatan",
        "name": "Nama",
        "type": "Tipe",
        "parentDepartment": "Departemen induk",
        "costCenterCode": "Kode pusat biaya",
        "revenueDepartmentCode": "Kode departemen pendapatan",
        "active": "Aktif — hapus centang untuk menonaktifkan secara lunak."
      },
      "placeholders": {
        "facility": "Pilih fasilitas…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "Kardiologi",
        "parentNone": "Tidak ada (tingkat teratas)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "Fasilitas wajib diisi",
        "codeRequired": "Kode wajib diisi",
        "nameRequired": "Nama wajib diisi"
      },
      "submit": {
        "create": "Buat Departemen",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Departemen berhasil dibuat",
        "updatedSuccess": "Departemen berhasil diperbarui",
        "saveError": "Gagal menyimpan departemen",
        "codeConflict": "Kode departemen sudah ada",
        "invalidData": "Data departemen tidak valid"
      }
    },
    "serviceType": {
      "clinical": "Klinis",
      "administrative": "Administratif",
      "support": "Pendukung"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak aktif"
    }
  },
  "provider": {
    "form": {
      "addTitle": "Tambah Tenaga Medis",
      "editTitle": "Edit Tenaga Medis",
      "fields": {
        "fullName": "Nama Lengkap",
        "npi": "NPI",
        "providerType": "Jenis Penyedia",
        "credentials": "Kualifikasi",
        "specialty": "Spesialisasi",
        "email": "Email",
        "phone": "Telepon",
        "facilityAssignments": "Penugasan Fasilitas",
        "status": "Status",
        "primaryFacility": "Fasilitas Utama",
        "loginAccount": "Akun Login"
      },
      "placeholders": {
        "specialty": "Pilih spesialisasi…",
        "credentials": "mis. MD, FACC",
        "providerType": "Pilih jenis penyedia",
        "noLoginAccount": "Tidak ada akun login"
      },
      "submit": {
        "create": "Buat",
        "update": "Perbarui"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Tenaga medis berhasil dibuat",
        "updatedSuccess": "Tenaga medis berhasil diperbarui",
        "saveError": "Gagal menyimpan tenaga medis"
      },
      "hints": {
        "loginAccount": "Menghubungkan klinisi ini dengan akun yang dipakainya untuk masuk. Tanpa itu, tanda tangan pendamping, verifikasi apoteker, dan pengakuan hasil kritis akan ditolak."
      }
    },
    "list": {
      "title": "Manajemen Penyedia Layanan",
      "subtitle": "Kelola penyedia layanan, kredensial, dan penugasan fasilitas",
      "columns": {
        "name": "Nama",
        "npi": "NPI",
        "specialty": "Spesialisasi",
        "credentials": "Kredensial",
        "facilities": "Fasilitas",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari berdasarkan nama, NPI, spesialisasi...",
        "allSpecialties": "Semua Spesialisasi",
        "allFacilities": "Semua Fasilitas",
        "allStatus": "Semua Status"
      },
      "actions": {
        "new": "Tambah Penyedia",
        "editTitle": "Edit penyedia",
        "scheduleTitle": "Templat jadwal",
        "viewCredentials": "Lihat kredensial"
      },
      "credentials": {
        "licenseLabel": "Lisensi",
        "none": "Tidak ada kredensial yang tercatat"
      },
      "empty": "Tidak ada penyedia ditemukan",
      "pagination": {
        "summary": "{{from}}-{{to}} dari {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "Halaman sebelumnya",
        "next": "Halaman berikutnya"
      },
      "toast": {
        "schedulePlaceholder": "Tautan templat jadwal (placeholder)"
      },
      "noLogin": "Tanpa login",
      "noLoginHint": "Tenaga ini belum terhubung ke akun login sehingga tidak dapat menandatangani pendamping, memverifikasi, atau mengakui."
    },
    "specialty": {
      "internalMedicine": "Penyakit Dalam",
      "cardiology": "Kardiologi",
      "emergencyMedicine": "Kedokteran Darurat",
      "pediatrics": "Anak",
      "pathology": "Patologi",
      "obstetricsGynecology": "Obstetri & Ginekologi",
      "surgery": "Bedah",
      "orthopedics": "Ortopedi",
      "neurology": "Neurologi",
      "psychiatry": "Psikiatri",
      "radiology": "Radiologi",
      "anesthesiology": "Anestesiologi",
      "oncology": "Onkologi",
      "dermatology": "Dermatologi",
      "ophthalmology": "Oftalmologi"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Nonaktif",
      "onLeave": "Cuti"
    },
    "providerType": {
      "physician": "Dokter",
      "nurse": "Perawat",
      "nursePractitioner": "Perawat Praktisi",
      "physicianAssistant": "Asisten Dokter",
      "pharmacist": "Apoteker",
      "therapist": "Terapis",
      "technician": "Teknisi",
      "other": "Lainnya",
      "midwife": "Bidan",
      "dentist": "Dokter Gigi",
      "pharmacyTechnician": "Teknisi Farmasi",
      "careAssistant": "Asisten Perawat",
      "dietitian": "Ahli Gizi",
      "socialWorker": "Pekerja Sosial",
      "traditionalMedicine": "Praktisi Pengobatan Tradisional"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "Tambah Lini Layanan",
      "editTitle": "Edit Lini Layanan",
      "subtitle": "Pengelompokan klinis tingkat tinggi (Kardiovaskular, Onkologi) yang menjadi induk layanan klinis spesifik.",
      "sections": {
        "serviceLine": "Lini Layanan"
      },
      "fields": {
        "healthSystem": "Sistem Kesehatan",
        "code": "Kode",
        "name": "Nama",
        "description": "Deskripsi",
        "active": "Aktif — hapus centang untuk menonaktifkan secara lunak."
      },
      "placeholders": {
        "healthSystem": "Pilih sistem kesehatan…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "Deskripsi singkat — cakupan, fokus penyakit, dll."
      },
      "errors": {
        "healthSystemRequired": "Sistem kesehatan wajib diisi",
        "codeRequired": "Kode wajib diisi",
        "nameRequired": "Nama wajib diisi"
      },
      "submit": {
        "create": "Buat Lini Layanan",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Lini layanan dibuat",
        "updatedSuccess": "Lini layanan diperbarui",
        "saveError": "Gagal menyimpan lini layanan",
        "codeConflict": "Kode lini layanan sudah ada",
        "invalidData": "Data lini layanan tidak valid"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "Tambah Layanan Klinis",
      "editTitle": "Edit Layanan Klinis",
      "subtitle": "Layanan klinis spesifik (Kardiologi, Lab EP). Dapat dikelompokkan di bawah lini layanan + diberi kode spesialisasi NUCC untuk penagihan + output direktori.",
      "sections": {
        "clinicalService": "Layanan Klinis",
        "specialtyBilling": "Spesialisasi + Penagihan"
      },
      "fields": {
        "code": "Kode",
        "name": "Nama",
        "serviceLine": "Lini Layanan",
        "description": "Deskripsi",
        "specialtyCode": "Kode spesialisasi NUCC",
        "specialtyDescription": "Deskripsi spesialisasi",
        "revenueDepartmentCode": "Kode departemen pendapatan",
        "active": "Aktif"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— tidak ada —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "Taksonomi NUCC — mendorong direktori penyedia + tampilan klaim."
      },
      "errors": {
        "codeRequired": "Kode wajib diisi",
        "nameRequired": "Nama wajib diisi"
      },
      "submit": {
        "create": "Buat Layanan Klinis",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Layanan klinis dibuat",
        "updatedSuccess": "Layanan klinis diperbarui",
        "saveError": "Gagal menyimpan layanan klinis",
        "codeConflict": "Kode layanan klinis sudah ada",
        "invalidData": "Data layanan klinis tidak valid"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "Penugasan Layanan ↔ Lokasi",
    "subtitle": "Layanan klinis mana yang berjalan di lokasi fisik mana, dengan jendela hari/waktu dan kapasitas opsional. Penjadwalan membaca ini untuk membangun slot yang tersedia. Hanya hapus lunak — mengakhiri penugasan mempertahankan riwayat untuk laporan.",
    "header": {
      "newAssignment": "Penugasan Baru",
      "toggleCancel": "Batal"
    },
    "form": {
      "title": "Penugasan baru",
      "fields": {
        "service": "Layanan Klinis",
        "location": "Lokasi",
        "dayOfWeekPattern": "Pola hari dalam minggu",
        "startTime": "Waktu mulai",
        "endTime": "Waktu selesai",
        "capacity": "Kapasitas %",
        "notes": "Catatan",
        "isPrimary": "Lokasi utama untuk layanan ini"
      },
      "placeholders": {
        "service": "Pilih layanan…",
        "location": "Pilih lokasi…",
        "dayOfWeekPattern": "1,3,5 (Sen/Rab/Jum)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "Hari ISO dipisah koma; kosong = setiap hari."
      },
      "errors": {
        "serviceLocationRequired": "Layanan + Lokasi wajib diisi"
      },
      "create": "Buat",
      "cancel": "Batal"
    },
    "filter": {
      "allFacilities": "Semua fasilitas",
      "allServices": "Semua layanan",
      "allLocations": "Semua lokasi",
      "allStatuses": "Semua status",
      "searchService": "Cari layanan…",
      "searchLocation": "Cari lokasi…",
      "facility": "Fasilitas",
      "serviceLine": "Lini layanan"
    },
    "columns": {
      "service": "Layanan",
      "location": "Lokasi",
      "facility": "Fasilitas",
      "when": "Kapan",
      "capacity": "Kapasitas",
      "effective": "Berlaku",
      "status": "Status",
      "actions": "Tindakan"
    },
    "status": {
      "active": "Aktif",
      "planned": "Direncanakan",
      "suspended": "Ditangguhkan",
      "ended": "Berakhir"
    },
    "dow": {
      "everyDay": "Setiap hari",
      "monFri": "Sen–Jum",
      "short": {
        "1": "Sen",
        "2": "Sel",
        "3": "Rab",
        "4": "Kam",
        "5": "Jum",
        "6": "Sab",
        "7": "Min"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "Lokasi utama",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "Jadikan utama",
      "unsetPrimary": "Batalkan utama",
      "endAssignment": "Akhiri penugasan"
    },
    "bulkEdit": {
      "title": "Edit Massal",
      "applyTo": "Terapkan ke yang dipilih",
      "selectedServices": "{{count}} layanan",
      "selectedLocations": "{{count}} lokasi",
      "save": "Simpan perubahan",
      "cancel": "Batal"
    },
    "confirm": {
      "endTitle": "Akhiri penugasan?",
      "endDescription": "{{service}} → {{location}}. Mengakhiri mempertahankan riwayat tetapi menghapus pasangan ini dari penjadwalan aktif.",
      "endConfirm": "Akhiri penugasan",
      "removeService": "Hapus {{service}} dari {{location}}?",
      "makePrimary": "Jadikan {{location}} lokasi utama untuk {{service}}?"
    },
    "toast": {
      "created": "Penugasan dibuat",
      "createError": "Gagal membuat penugasan",
      "ended": "Penugasan diakhiri",
      "endError": "Gagal mengakhiri penugasan",
      "primaryError": "Gagal mengalihkan utama",
      "updated": "Penugasan diperbarui"
    },
    "empty": "Tidak ada penugasan yang cocok dengan filter ini. Klik Penugasan Baru untuk menambahkan."
  },
  "integration": {
    "list": {
      "title": "Manajemen Integrasi",
      "subtitle": "Integrasi sistem HL7, FHIR, dan pihak ketiga",
      "refresh": "Segarkan",
      "addEndpoint": "Tambah Endpoint",
      "searchPlaceholder": "Cari integrasi…",
      "tabs": {
        "endpoints": "Endpoint",
        "messageLog": "Log Pesan",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "Total Endpoint",
        "connected": "Terhubung",
        "errors": "Kesalahan",
        "totalMessages": "Total Pesan"
      }
    },
    "columns": {
      "status": "Status",
      "name": "Nama",
      "type": "Tipe",
      "direction": "Arah",
      "url": "URL",
      "tls": "TLS",
      "auth": "Auth",
      "lastMessage": "Pesan Terakhir",
      "messages": "Pesan",
      "errors": "Kesalahan",
      "backlog": "Tunggakan",
      "health": "Kesehatan",
      "actions": "Tindakan",
      "backlogTitle": "Pesan keluar tertunda + usia tertunda terlama",
      "healthTitle": "Status kesehatan — merah jika antrean terblokir oleh pesan yang gagal"
    },
    "badge": {
      "tlsCerts": "sertifikat: {{cert}}, kunci: {{key}}, CA: {{ca}}",
      "yes": "ya",
      "no": "tidak",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "Token Bearer tersimpan",
      "bearerNoToken": "bearer (token belum disetel)",
      "mtlsCert": "Sertifikat klien mTLS",
      "awaitingAck": "{{n}} menunggu ACK",
      "oldest": "tertua {{age}}",
      "never": "Tidak pernah",
      "blocked": "TERBLOKIR",
      "waiting": "MENUNGGU",
      "ok": "OK",
      "blockedTitle": "Pesan yang gagal memblokir antrean integrasi ini. Klik untuk membuka log terfilter.",
      "waitingTitle": "Pesan menunggu ACK aplikasi mode ditingkatkan dari mitra. Klik untuk membuka log terfilter.",
      "okTitle": "Semua hijau — klik untuk membuka log pesan integrasi ini.",
      "receives": "Menerima"
    },
    "action": {
      "testConnection": "Uji koneksi",
      "restartTls": "Mulai ulang — terapkan TLS yang baru dirotasi",
      "investigate": "Throughput, latensi, dan kegagalan terbaru",
      "edit": "Edit"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "50 pesan terbaru",
      "columns": {
        "time": "Waktu",
        "id": "ID",
        "direction": "Arah",
        "type": "Tipe",
        "source": "Sumber",
        "summary": "Ringkasan",
        "status": "Status"
      },
      "dir": {
        "in": "MASUK",
        "out": "KELUAR"
      }
    },
    "fhir": {
      "serverStatusHeader": "Status Server FHIR R4",
      "serverOnline": "Server Online",
      "supportedResources": "Sumber Daya yang Didukung",
      "version": "Versi",
      "externalHeader": "Endpoint FHIR Eksternal",
      "registerEndpoint": "Daftarkan Endpoint",
      "columns": {
        "name": "Nama",
        "baseUrl": "URL Dasar",
        "auth": "Auth",
        "status": "Status",
        "lastChecked": "Terakhir Diperiksa",
        "actions": "Tindakan"
      },
      "emptyEndpoints": "Belum ada endpoint FHIR eksternal yang terdaftar.",
      "revoked": "dicabut",
      "statusOk": "OK",
      "statusError": "Kesalahan",
      "testMetadata": "Uji /metadata",
      "edit": "Edit",
      "revoke": "Cabut"
    },
    "smart": {
      "header": "Aplikasi SMART Terdaftar",
      "registerApp": "Daftarkan Aplikasi",
      "columns": {
        "appName": "Nama Aplikasi",
        "clientId": "Client ID",
        "scopes": "Cakupan",
        "status": "Status",
        "lastModified": "Terakhir Diubah",
        "actions": "Tindakan"
      },
      "emptyApps": "Belum ada aplikasi SMART yang terdaftar.",
      "edit": "Edit",
      "rotateSecret": "Rotasi rahasia klien",
      "revoke": "Cabut"
    },
    "secretModal": {
      "title": "Simpan client secret ini sekarang",
      "body": "Secret ini hanya ditampilkan satu kali. Jika hilang, rotasikan secret untuk menerbitkan yang baru.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Salin Client ID",
      "copyClientSecret": "Salin Client Secret",
      "saved": "Saya sudah menyimpannya"
    },
    "drawer": {
      "header": "Integrasi #{{id}}",
      "refresh": "Segarkan",
      "close": "Tutup",
      "queueBlocked": "Antrean terblokir",
      "queueBlockedBody": "Pesan yang gagal menghentikan integrasi ini dari mengirim. Pesan di belakangnya menunggu sampai operator bertindak.",
      "investigate": "Selidiki",
      "tiles": {
        "backlog": "Tunggakan",
        "success24h": "Sukses 24h",
        "avgLatency24h": "Latensi rata-rata 24h",
        "awaitingAck": "Menunggu app-ACK"
      },
      "charts": {
        "throughput": "Throughput (24h)",
        "throughputSub": "Bucket per jam. Bertumpuk: keluar selesai + gagal; masuk di sumbu sekunder.",
        "successRate": "Tingkat keberhasilan (24h)",
        "successRateSub": "Per bucket: selesai / (selesai + gagal). Celah adalah bucket menganggur.",
        "ackLatency": "Latensi ACK (24h)",
        "ackLatencySub": "Waktu antara pengiriman dan ACK diterima. avg garis penuh, p95 putus-putus."
      },
      "series": {
        "outCompleted": "Keluar · selesai",
        "outFailed": "Keluar · gagal",
        "inReceived": "Masuk · diterima",
        "successPct": "Sukses %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "Kegagalan terbaru",
      "viewAll": "Lihat semua →",
      "noFailures": "Tidak ada pesan gagal di jendela terbaru. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "Terhubung",
    "disconnected": "Terputus",
    "error": "Kesalahan"
  },
  "integrationDirection": {
    "server": "Server",
    "client": "Klien"
  },
  "messageStatus": {
    "sent": "Terkirim",
    "received": "Diterima",
    "error": "Kesalahan",
    "acknowledged": "Dikonfirmasi"
  },
  "smartAppStatus": {
    "active": "Aktif",
    "revoked": "Dicabut"
  },
  "interfaceMessageStatus": {
    "pending": "Tertunda",
    "processing": "Memproses",
    "completed": "Selesai",
    "received": "Diterima",
    "processed": "Diproses",
    "failed": "Gagal",
    "error": "Kesalahan",
    "rejected": "Ditolak",
    "deadLetter": "Surat Mati",
    "skipped": "Dilewati",
    "awaitingAppAck": "Menunggu ACK Aplikasi"
  },
  "interfaceDirection": {
    "in": "Masuk",
    "out": "Keluar"
  },
  "attemptOutcome": {
    "sent": "Terkirim",
    "appNak": "App NAK",
    "timeout": "Waktu habis",
    "networkError": "Kesalahan jaringan"
  },
  "fhirEndpoint": {
    "titleEdit": "Edit Endpoint FHIR",
    "titleRegister": "Daftarkan Endpoint FHIR",
    "subtitle": "Mitra FHIR R4 eksternal yang dihubungi gateway secara outbound. Tombol Test Connection pada daftar integrasi memeriksa <code>/metadata</code> dengan auth + TLS yang dikonfigurasi.",
    "back": "Kembali",
    "cancel": "Batal",
    "storedBlank": "Tersimpan — biarkan kosong untuk mempertahankan",
    "save": {
      "changes": "Simpan Perubahan",
      "register": "Daftarkan Endpoint"
    },
    "section": {
      "basics": "Dasar",
      "auth": "Autentikasi",
      "tls": "TLS"
    },
    "fields": {
      "name": "Nama",
      "baseUrl": "Base URL",
      "description": "Deskripsi",
      "active": "Aktif — hapus centang untuk soft-revoke.",
      "method": "Metode",
      "username": "Nama pengguna",
      "password": "Kata sandi",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// wajib (http://localhost diterima untuk pengembangan). /metadata di akhir ditambahkan otomatis saat Test.",
      "oauth2": "Pengambilan token OAuth2 sudah terhubung di sisi admin; pengambil runtime menyusul. Untuk saat ini, isi nilai dan jalankan Test untuk memverifikasi sisa konfigurasi.",
      "tls": "Tempel root CA untuk menyematkan sertifikat server mitra, atau tempel client cert + key untuk mTLS. CA saja berfungsi dengan penyimpanan root sistem untuk CA yang dikenal."
    },
    "option": {
      "method": {
        "none": "Tidak ada",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — opsional untuk sebagian besar mitra",
      "clientCertRequired": "Client certificate (PEM) — wajib",
      "clientCertMtls": "Client certificate (PEM) — untuk mTLS",
      "clientKeyRequired": "Client private key (PEM) — wajib",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "Nama wajib diisi",
      "baseUrlRequired": "Base URL wajib diisi",
      "baseUrlInvalid": "URL dasar harus berupa URL http(s) yang valid",
      "basicUsername": "Basic auth memerlukan nama pengguna",
      "basicPassword": "Basic auth memerlukan kata sandi",
      "bearerToken": "Bearer auth memerlukan token",
      "clientCertKey": "Autentikasi Client-certificate memerlukan cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "Edit Aplikasi SMART",
    "titleRegister": "Daftarkan Aplikasi SMART",
    "subtitle": "Registrasi klien SMART on FHIR. Client ID dibuat otomatis untuk Anda; client secret hanya ditampilkan satu kali setelah pembuatan atau rotasi.",
    "back": "Kembali",
    "cancel": "Batal",
    "save": "Simpan Perubahan",
    "register": "Daftarkan",
    "fields": {
      "appName": "Nama Aplikasi",
      "redirectUris": "URI Pengalihan",
      "scopes": "Cakupan (scope)",
      "launchUrl": "URL Peluncuran",
      "logoUrl": "URL Logo",
      "active": "Aktif — hapus centang untuk mencabut lunak aplikasi ini."
    },
    "placeholder": {
      "appName": "Peluncur EHR Saya"
    },
    "helper": {
      "redirectUris": "Satu URI per baris. https:// wajib (http://localhost juga diterima untuk pengembangan)."
    },
    "secretModal": {
      "title": "Simpan client secret ini sekarang",
      "body": "Secret ini hanya ditampilkan satu kali. Jika hilang, rotasikan secret untuk menerbitkan yang baru.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Salin Client ID",
      "copyClientSecret": "Salin Client Secret",
      "saved": "Saya sudah menyimpannya"
    },
    "validation": {
      "nameRequired": "Nama wajib diisi",
      "redirectUriRequired": "Diperlukan setidaknya satu URI pengalihan",
      "scopeRequired": "Diperlukan setidaknya satu cakupan (scope)"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "Log Pesan Antarmuka",
      "subtitle": "Pesan HL7 masuk + keluar di setiap integrasi aktif.",
      "refresh": "Segarkan",
      "loading": "Memuat pesan…",
      "empty": "Tidak ada pesan yang cocok dengan filter saat ini.",
      "pagination": "{{total}} pesan • halaman {{page}} dari {{pages}}",
      "prev": "Sebelumnya",
      "next": "Berikutnya",
      "archived": "(arsip)"
    },
    "relative": {
      "secondsAgo": "{{n}}d lalu",
      "minutesAgo": "{{n}}mnt lalu",
      "hoursAgo": "{{n}}j lalu"
    },
    "filter": {
      "header": "Filter",
      "direction": "Arah",
      "status": "Status",
      "messageType": "Jenis pesan",
      "msh10": "MSH-10 mengandung",
      "integrationId": "ID Integrasi",
      "includeArchive": "Sertakan arsip",
      "clear": "Hapus filter",
      "any": "Apa saja",
      "messageTypePlaceholder": "mis. ADT^A01",
      "controlIdPlaceholder": "id kontrol"
    },
    "columns": {
      "id": "ID",
      "dir": "Arah",
      "integ": "Integ",
      "type": "Jenis",
      "msh10": "MSH-10",
      "status": "Status",
      "ack": "ACK",
      "attempts": "Percobaan",
      "when": "Kapan"
    },
    "detail": {
      "eyebrow": "Pesan {{direction}}",
      "close": "Tutup",
      "loading": "Memuat…",
      "tabs": {
        "overview": "Ikhtisar",
        "rawHl7": "HL7 mentah",
        "attempts": "Percobaan"
      },
      "operatorActions": "Tindakan operator",
      "retry": "Coba lagi",
      "skip": "Lewati",
      "abandon": "Tinggalkan",
      "resendAsNew": "Kirim ulang sebagai baru",
      "skipReason": "Alasan melewati",
      "abandonReason": "Alasan meninggalkan",
      "actionsHelper": "Tindakan diaudit dengan ID pengguna + alasan Anda. Lewati + Tinggalkan memerlukan alasan.",
      "overview": {
        "direction": "Arah",
        "integration": "Integrasi",
        "type": "Tipe",
        "msh10": "MSH-10",
        "status": "Status",
        "ackCode": "Kode ACK",
        "attempts": "Percobaan",
        "created": "Dibuat",
        "ackReceived": "ACK diterima",
        "nextRetry": "Percobaan berikutnya",
        "ackText": "Teks ACK",
        "lastError": "Kesalahan terakhir",
        "sourceEventId": "ID peristiwa sumber"
      },
      "rawViewer": {
        "permissionDenied": "HL7 mentah yang didekripsi memerlukan izin <code>INTERFACE_OPERATE</code>.",
        "notAvailable": "Payload mentah tidak tersedia untuk pesan ini.",
        "bytes": "{{bytes}} byte",
        "copy": "Salin"
      },
      "attempts": {
        "inboundInfo": "Riwayat percobaan dilacak hanya untuk pesan keluar. Pesan masuk diproses sekali per MSH-10; pengiriman ulang mengembalikan ACK yang di-cache tanpa percobaan baru.",
        "totalAttempts": "Total percobaan",
        "nextAt": " (berikutnya pada {{time}})",
        "refresh": "Segarkan",
        "loading": "Memuat percobaan…",
        "error": "Gagal memuat percobaan.",
        "empty": "Belum ada percobaan yang tercatat. Worker menulis satu baris per pengiriman; daftar ini terisi setelah klaim pertama.",
        "columns": {
          "when": "Kapan",
          "outcome": "Hasil",
          "ack": "ACK",
          "duration": "Durasi",
          "detail": "Detail"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "Aplikasi Pihak Ketiga",
      "subtitle": "Konfigurasikan aplikasi eksternal yang dapat diluncurkan dari VynaEMR dengan konteks pasien",
      "addApp": "Tambah Aplikasi",
      "searchPlaceholder": "Cari aplikasi berdasarkan nama, kode, atau kategori...",
      "emptyTitle": "Tidak ada aplikasi yang dikonfigurasi",
      "emptyBody": "Tambahkan aplikasi eksternal seperti penampil PACS, portal lab, atau sistem farmasi.",
      "columns": {
        "application": "Aplikasi",
        "category": "Kategori",
        "url": "URL",
        "security": "Keamanan",
        "display": "Tampilan",
        "status": "Status",
        "actions": "Tindakan"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "Ditandatangani JWT",
      "hmac": "HMAC",
      "hmacSigned": "Ditandatangani HMAC",
      "none": "Tidak ada",
      "chart": "Bagan",
      "sidebar": "Bilah sisi",
      "active": "Aktif",
      "inactive": "Nonaktif"
    },
    "action": {
      "testLaunch": "Uji Peluncuran",
      "edit": "Edit",
      "deactivate": "Nonaktifkan"
    },
    "form": {
      "titleEdit": "Edit Aplikasi",
      "titleNew": "Aplikasi Baru",
      "fields": {
        "appCode": "Kode Aplikasi",
        "appName": "Nama Aplikasi",
        "category": "Kategori",
        "baseUrl": "URL Dasar",
        "launchMethod": "Metode Peluncuran",
        "paramMappings": "Pemetaan Parameter",
        "enableJwt": "Aktifkan Penandatanganan Token JWT",
        "sharedSecret": "Rahasia Bersama (kunci penandatanganan JWT)",
        "enableHmac": "Aktifkan Tanda Tangan URL (HMAC)",
        "hmacKey": "Kunci HMAC",
        "requiredPermission": "Izin Diperlukan",
        "displayOrder": "Urutan Tampilan",
        "showInChart": "Tampilkan di Bagan",
        "showInSidebar": "Tampilkan di Bilah Sisi"
      },
      "placeholder": {
        "appCode": "mis. pacs_viewer",
        "appName": "mis. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "Nama param URL",
        "unchanged": "(tidak berubah)",
        "sharedSecret": "Masukkan rahasia bersama",
        "hmacKey": "Masukkan kunci HMAC",
        "requiredPermission": "mis. RESULT_VIEW (kosong = pengguna mana pun)"
      },
      "addParameter": "Tambah Parameter",
      "cancel": "Batal",
      "submitUpdate": "Perbarui Aplikasi",
      "submitCreate": "Buat Aplikasi"
    },
    "paramSource": {
      "patientMrn": "MRN Pasien",
      "patientName": "Nama Pasien",
      "patientDob": "DOB Pasien",
      "encounterId": "ID Kunjungan",
      "encounterNumber": "Nomor Kunjungan",
      "orderNumber": "Nomor Pesanan",
      "userName": "Nama Pengguna Saat Ini",
      "userId": "ID Pengguna Saat Ini",
      "timestamp": "Stempel Waktu Saat Ini"
    },
    "launch": "Luncurkan {{name}}"
  },
  "integrationForm": {
    "titleEdit": "Edit Integrasi",
    "titleAdd": "Tambah Integrasi",
    "subtitle": "Antarmuka MLLP dan HL7-over-HTTP yang didukung oleh VynaHL7. Materi sertifikat disimpan pada baris integrasi; rotasi berlaku saat server atau klien dimulai ulang berikutnya.",
    "back": "Kembali",
    "cancel": "Batal",
    "saveChanges": "Simpan Perubahan",
    "addIntegration": "Tambah Integrasi",
    "storedBlank": "Tersimpan — kosongkan untuk mempertahankan",
    "selectSibling": "— pilih integrasi setingkat —",
    "section": {
      "basics": "Dasar",
      "connection": "Koneksi",
      "tls": "TLS / mTLS",
      "auth": "Autentikasi",
      "ackDelivery": "Konfirmasi & Pengiriman",
      "outboundRouting": "Perutean keluar",
      "inboundTrust": "Kepercayaan masuk"
    },
    "fields": {
      "name": "Nama",
      "type": "Tipe",
      "direction": "Arah",
      "description": "Deskripsi",
      "active": "Aktif — hapus centang untuk menonaktifkan lunak antarmuka ini.",
      "host": "Host",
      "port": "Port",
      "enableTls": "Aktifkan TLS — menggunakan",
      "serverCert": "Sertifikat server (PEM)",
      "clientCert": "Sertifikat klien (PEM) — opsional untuk mTLS",
      "serverKey": "Kunci privat server (PEM)",
      "clientKey": "Kunci privat klien (PEM)",
      "serverCa": "Penyimpanan kepercayaan CA klien (PEM) — untuk mTLS",
      "clientCa": "Penyimpanan kepercayaan CA server (PEM) — opsional, kembali ke root sistem",
      "method": "Metode",
      "username": "Nama pengguna",
      "password": "Kata sandi",
      "bearerToken": "Token Bearer",
      "inboundAck": "Kebijakan ACK masuk",
      "outboundAck": "Kebijakan ACK keluar",
      "processingTimeout": "Batas waktu pemrosesan (md)",
      "pendingAckTtl": "TTL ACK tertunda (detik)",
      "networkRetry": "Maks coba ulang jaringan",
      "appNakRetry": "Maks coba ulang NAK aplikasi",
      "reverseIntegration": "Integrasi kanal balik",
      "outboundTypes": "Jenis pesan yang diterima",
      "outboundEvents": "Langganan tingkat peristiwa",
      "receivingApplication": "Aplikasi penerima (MSH-5)",
      "receivingFacility": "Fasilitas penerima (MSH-6)",
      "inboundTrustProfile": "Mitra ini boleh"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "Catatan singkat tentang antarmuka ini — pemilik, tujuan, jenis pesan, dll.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "Alamat bind. Gunakan 0.0.0.0 untuk mendengarkan di semua antarmuka.",
      "hostClient": "Host jarak jauh yang harus dihubungi klien ini.",
      "tlsHandshake": "untuk jabat tangan.",
      "authClientCert": "Sertifikat/kunci klien berasal dari bagian TLS di atas.",
      "authNone": "Tidak ada header autentikasi HTTP yang dilampirkan.",
      "authRs7": "{{call}} menghubungkan ini ke setiap permintaan keluar.",
      "ackDefaults": "Mengontrol cara gateway meng-ACK pesan HL7 masuk dan cara menafsirkan ACK respons pada pengiriman keluar. Nilai default",
      "ackDefaultsTail": "sesuai perilaku pra-0.19.0 — ubah per mitra sesuai kebutuhan.",
      "processingTimeout": "Batas untuk pemrosesan inline ACK aplikasi sinkron. Habis waktu → AE + coba ulang antrean latar belakang.",
      "pendingAckTtl": "Waktu tunggu ACK aplikasi mode lanjutan sebelum penyapu menghabiskan waktunya.",
      "networkRetry": "Coba ulang untuk kesalahan transport sebelum antrean diblokir.",
      "appNakRetry": "Coba ulang untuk AE/AR/CE/CR — biasanya 2–3 karena payload yang sama jarang berhasil saat dicoba ulang.",
      "reverse": "Mode lanjutan mengirim ACK aplikasi sebenarnya melalui integrasi setingkat yang menunjuk ke endpoint balik mitra. Buat integrasi setingkat sebagai baris terpisah dulu, lalu tautkan di sini.",
      "outboundRouting": "Apa yang diterima mitra ini. Tanpa pilihan apa pun, integrasi ini bukan tujuan keluar dan tidak ada pesan yang dikirim kepadanya.",
      "outboundEvents": "Opsional, dipisahkan koma. Lebih sempit daripada satu jenis penuh — untuk mitra yang hanya menginginkan peristiwa tertentu.",
      "receivingDefaults": "MSH-5 dan MSH-6 menyebut penerima pada setiap pesan yang dikirim ke sini. Kosongkan untuk memakai nama antarmuka.",
      "inboundTrust": "Apa yang boleh dinyatakan mitra ini tentang identitas pasien. Autentikasi menyatakan siapa yang terhubung; pengaturan ini menyatakan apa yang boleh mereka sampaikan kepada kami. Biarkan pada default penerapan kecuali peer ini benar-benar master pendaftaran."
    },
    "option": {
      "type": {
        "mllp": "MLLP (HL7 v2 melalui TCP)",
        "hoh": "HoH (HL7 melalui HTTPS)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "Klien (keluar)",
        "server": "Server (masuk)"
      },
      "method": {
        "none": "Tidak ada",
        "basic": "HTTP Basic",
        "bearer": "Token Bearer",
        "clientCert": "Sertifikat klien (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "AA segera (default saat ini)",
        "honorMsh16": "baca MSH-15/16 per pesan",
        "forceSync": "proses inline, AA/AE/AR sesuai hasil",
        "forceEnhanced": "CA sekarang + ACK aplikasi via kanal balik"
      },
      "outbound": {
        "fireAndForget": "kirim lalu lupakan (default saat ini)",
        "expectSync": "set MSH-16=AL, coba ulang saat AE/AR",
        "expectEnhanced": "tunggu CA + ACK aplikasi lanjutan"
      }
    },
    "validation": {
      "nameRequired": "Nama wajib diisi",
      "hostRequired": "Host wajib diisi",
      "mllpPort": "Integrasi MLLP memerlukan port",
      "portNumber": "Port harus berupa angka",
      "tlsServerCertKey": "Server TLS memerlukan sertifikat dan kunci",
      "basicUsername": "Autentikasi Basic memerlukan nama pengguna",
      "basicPassword": "Autentikasi Basic memerlukan kata sandi",
      "bearerToken": "Autentikasi Bearer memerlukan token",
      "enhancedReverse": "Mode ACK lanjutan memerlukan integrasi balik — pilih salah satu di bawah.",
      "outboundEvent": "\"{{value}}\" bukan pesan yang dikirim sistem ini — gunakan jenis seperti ADT, atau peristiwa seperti ADT^A01."
    },
    "trust": {
      "useDeploymentDefault": "Gunakan default penerapan",
      "observer": "Pengamat — tidak pernah membuat atau mengubah pasien",
      "demographics": "Demografi — dapat mengoreksi pasien yang kami miliki, termasuk pemberitahuan kematian; tidak membuat",
      "registration": "Pendaftaran — juga dapat membuat pasien dan menggabungkan rekam medis"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "Pencitraan",
    "laboratory": "Laboratorium",
    "pharmacy": "Farmasi",
    "specialty": "Spesialisasi",
    "portal": "Portal",
    "billing": "Penagihan",
    "other": "Lainnya"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "Pengalihan",
    "popup": "Jendela Popup",
    "iframe": "iframe",
    "newTab": "Tab Baru"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "Edit Aturan CDS",
      "titleCreate": "Buat Aturan CDS",
      "ruleName": "Nama Aturan",
      "ruleType": "Jenis Aturan",
      "selectPlaceholder": "Pilih…",
      "severity": "Tingkat Keparahan",
      "triggerEvent": "Peristiwa Pemicu",
      "actionType": "Jenis Tindakan",
      "description": "Deskripsi",
      "active": "Aktif",
      "cancel": "Batal",
      "submitUpdate": "Perbarui Aturan",
      "submitCreate": "Buat Aturan",
      "createdOk": "Aturan berhasil dibuat",
      "createFailed": "Gagal membuat aturan",
      "updatedOk": "Aturan berhasil diperbarui",
      "updateFailed": "Gagal memperbarui aturan",
      "validation": {
        "nameRequired": "Nama aturan wajib diisi",
        "typeRequired": "Jenis aturan wajib diisi",
        "descriptionRequired": "Deskripsi wajib diisi",
        "triggerRequired": "Peristiwa pemicu wajib diisi",
        "actionRequired": "Jenis tindakan wajib diisi"
      }
    },
    "list": {
      "title": "Aturan CDS",
      "subtitle": "Kelola aturan dukungan keputusan klinis",
      "addRule": "Tambah Aturan",
      "loading": "Memuat aturan CDS…",
      "loadError": "Gagal memuat aturan CDS.",
      "empty": "Belum ada aturan CDS yang dikonfigurasi.",
      "columns": {
        "ruleName": "Nama Aturan",
        "type": "Jenis",
        "severity": "Tingkat Keparahan",
        "description": "Deskripsi",
        "status": "Status",
        "actions": "Tindakan"
      },
      "toggleActive": "Klik untuk menonaktifkan",
      "toggleInactive": "Klik untuk mengaktifkan",
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "editRule": "Edit aturan",
      "statusUpdated": "Status aturan diperbarui",
      "statusUpdateFailed": "Gagal memperbarui status aturan"
    }
  },
  "cdsSeverity": {
    "info": "Info",
    "warning": "Peringatan",
    "critical": "Kritis"
  },
  "cdsTriggerEvent": {
    "orderSign": "Tanda Tangan Pesanan",
    "orderSelect": "Pilih Pesanan",
    "patientView": "Lihat Pasien",
    "medicationPrescribe": "Resep Obat",
    "resultReceived": "Hasil Diterima",
    "patientAdmit": "Penerimaan Pasien"
  },
  "cdsActionType": {
    "alert": "Peringatan",
    "warning": "Waspada",
    "hardStop": "Penghentian Paksa",
    "suggestion": "Saran",
    "notification": "Notifikasi"
  },
  "cdsRuleType": {
    "drugInteraction": "Interaksi Obat",
    "drugAllergy": "Alergi Obat",
    "duplicateOrder": "Pesanan Duplikat",
    "custom": "Kustom",
    "clinicalAlert": "Peringatan Klinis",
    "sepsisScreen": "Skrining Sepsis"
  },
  "system": {
    "title": "Konfigurasi Sistem",
    "subtitle": "Pengaturan aplikasi, keamanan, dan kesehatan sistem",
    "restartServices": "Mulai Ulang Layanan",
    "restartToast": "Mulai ulang layanan (placeholder - memerlukan konfirmasi)",
    "loadError": "Gagal memuat Konfigurasi Sistem",
    "section": {
      "systemInfo": "Informasi Sistem",
      "systemInfoDesc": "Versi, waktu aktif, dan kesehatan layanan",
      "general": "Pengaturan Umum",
      "generalDesc": "Nama aplikasi, zona waktu, dan merek",
      "security": "Pengaturan Keamanan",
      "securityDesc": "Kebijakan kata sandi, MFA, dan manajemen sesi",
      "notifications": "Pengaturan Notifikasi",
      "notificationsDesc": "Konfigurasi gerbang email dan SMS",
      "integration": "Default Integrasi",
      "integrationDesc": "Konfigurasi default MLLP, FHIR, dan HL7",
      "featureFlags": "Bendera Fitur",
      "featureFlagsDesc": "Aktifkan atau nonaktifkan fitur sistem",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "Versi",
      "uptime": "Waktu Aktif",
      "database": "Basis Data",
      "redis": "Redis",
      "microservices": "Layanan Mikro",
      "conn": "koneksi"
    },
    "uptime": {
      "running": "Berjalan",
      "unknown": "Tidak Diketahui",
      "up": "Aktif"
    },
    "subsection": {
      "passwordPolicy": "Kebijakan Kata Sandi",
      "mfa": "Autentikasi Multi-Faktor",
      "sessionLockout": "Sesi & Penguncian",
      "emailConfig": "Konfigurasi Email",
      "smsGateway": "Gerbang SMS",
      "mllpDefaults": "Default MLLP",
      "fhirConfig": "Konfigurasi FHIR",
      "hl7Encoding": "Pengodean HL7 v2"
    },
    "fields": {
      "appName": "Nama Aplikasi",
      "timezone": "Zona Waktu",
      "dateFormat": "Format Tanggal",
      "supportEmail": "Email Dukungan",
      "logoUrl": "URL Logo",
      "maintenanceMode": "Mode Pemeliharaan (menonaktifkan akses pengguna)",
      "upload": "Unggah",
      "minPasswordLength": "Panjang Kata Sandi Minimum",
      "passwordExpiry": "Kedaluwarsa Kata Sandi (hari)",
      "requireUppercase": "Wajib huruf besar",
      "requireNumbers": "Wajib angka",
      "requireSpecialChars": "Wajib karakter khusus",
      "enableMfa": "Aktifkan MFA",
      "mfaMethod": "Metode MFA",
      "sessionTimeout": "Batas Waktu Sesi (menit)",
      "maxLoginAttempts": "Maks Percobaan Masuk",
      "lockoutDuration": "Durasi Penguncian (menit)",
      "smtpHost": "Host SMTP",
      "smtpPort": "Port SMTP",
      "smtpUser": "Pengguna SMTP",
      "fromEmail": "Email Pengirim",
      "useTls": "Gunakan TLS",
      "enabled": "Aktif",
      "provider": "Penyedia",
      "fromNumber": "Nomor Pengirim",
      "defaultPort": "Port Default",
      "timeoutSeconds": "Batas Waktu (detik)",
      "retryCount": "Jumlah Percobaan Ulang",
      "fhirBaseUrl": "FHIR Base URL",
      "authMethod": "Metode Autentikasi",
      "fieldSeparator": "Pemisah Bidang",
      "encodingChars": "Karakter Pengodean",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "Asia/Singapura (UTC+8)",
        "hongKong": "Asia/Hong Kong (UTC+8)",
        "kualaLumpur": "Asia/Kuala Lumpur (UTC+8)",
        "bangkok": "Asia/Bangkok (UTC+7)",
        "tokyo": "Asia/Tokyo (UTC+9)",
        "kolkata": "Asia/Kolkata (UTC+5:30)",
        "sydney": "Australia/Sydney (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (Aplikasi Autentikator)",
        "sms": "SMS",
        "email": "Email"
      },
      "fhirAuth": {
        "none": "Tidak Ada",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "Simpan Pengaturan Umum",
      "security": "Simpan Pengaturan Keamanan",
      "notifications": "Simpan Pengaturan Notifikasi",
      "integration": "Simpan Integrasi",
      "features": "Simpan Bendera Fitur",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "Umum",
      "security": "Keamanan",
      "notifications": "Notifikasi",
      "integration": "Integrasi",
      "features": "Bendera Fitur",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "Unggah logo (placeholder)",
      "saved": "Pengaturan {{section}} berhasil disimpan",
      "saveFailed": "Gagal menyimpan pengaturan"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "Penggabungan Pasien",
        "description": "Aktifkan fungsi penggabungan/pembatalan gabung pasien"
      },
      "breakGlass": {
        "label": "Akses Darurat",
        "description": "Izinkan penggantian darurat untuk rekaman terbatas"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "Ekspos endpoint FHIR R4 untuk sistem eksternal"
      },
      "smartApps": {
        "label": "Aplikasi SMART on FHIR",
        "description": "Izinkan aplikasi SMART pihak ketiga terhubung"
      },
      "clinicalDecisionSupport": {
        "label": "Dukungan Keputusan Klinis",
        "description": "Aktifkan CDS hooks untuk entri pesanan"
      },
      "telemedicine": {
        "label": "Modul Telemedisin",
        "description": "Konsultasi video dan pemantauan jarak jauh"
      },
      "patientPortal": {
        "label": "Portal Pasien",
        "description": "Portal untuk pasien melihat rekaman dan janji temu"
      },
      "analyticsDashboard": {
        "label": "Dasbor Analitik",
        "description": "Dasbor analitik dan pelaporan tingkat lanjut"
      },
      "medicationBarcode": {
        "label": "Pemindaian Barcode Obat",
        "description": "Verifikasi barcode untuk administrasi obat"
      },
      "autoCoding": {
        "label": "Pengodean Otomatis (ICD/CPT)",
        "description": "Pengodean diagnosis dan prosedur berbantuan AI"
      }
    }
  },
  "audit": {
    "title": "Log Audit",
    "subtitle": "Log aktivitas sistem dengan pelacakan perubahan terperinci",
    "exportCsv": "Ekspor CSV",
    "exportToast": "Mengekspor {{count}} entri audit sebagai CSV (placeholder)",
    "searchPlaceholder": "Cari berdasarkan pengguna…",
    "advanced": "Lanjutan",
    "breakGlassOnly": "Hanya Akses Darurat",
    "fromTo": "Dari / Sampai:",
    "fromDate": "Tanggal mulai",
    "toDate": "Tanggal akhir",
    "clearFilters": "Hapus semua filter",
    "entriesFound": "{{count}} entri ditemukan",
    "noMatch": "Tidak ada entri audit yang cocok dengan filter Anda",
    "viewDetails": "Lihat detail",
    "detail": {
      "title": "Detail Entri Audit",
      "timestamp": "Stempel waktu",
      "user": "Pengguna",
      "action": "Tindakan",
      "resource": "Sumber daya",
      "ipAddress": "Alamat IP",
      "breakGlass": "Akses Darurat",
      "yes": "Ya",
      "no": "Tidak",
      "details": "Detail",
      "dataChanges": "Perubahan Data",
      "before": "Sebelum",
      "after": "Sesudah",
      "result": "Hasil"
    },
    "columns": {
      "timestamp": "Stempel waktu",
      "user": "Pengguna",
      "action": "Tindakan",
      "resource": "Sumber daya",
      "resourceId": "ID Sumber daya",
      "ipAddress": "Alamat IP",
      "details": "Detail",
      "view": "Lihat"
    },
    "filter": {
      "action": {
        "all": "Semua Tindakan",
        "create": "Buat",
        "read": "Baca",
        "update": "Perbarui",
        "delete": "Hapus",
        "login": "Masuk",
        "logout": "Keluar",
        "export": "Ekspor",
        "breakGlass": "Akses Darurat"
      },
      "resource": {
        "all": "Semua Sumber Daya",
        "patient": "Pasien",
        "encounter": "Kunjungan",
        "order": "Pesanan",
        "result": "Hasil",
        "medication": "Obat",
        "user": "Pengguna",
        "system": "Sistem"
      }
    },
    "pagination": {
      "first": "Pertama",
      "last": "Terakhir",
      "pageOf": "Halaman {{page}} dari {{pages}}",
      "range": "{{from}}-{{to}} dari {{total}}"
    }
  },
  "taxonomy": {
    "title": "Taksonomi Klinis",
    "subtitle": "Lini layanan mengelompokkan layanan klinis terkait (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). Keduanya menjadi masukan untuk matriks penetapan layanan ↔ lokasi yang digunakan penjadwalan.",
    "addServiceLine": "Tambah Lini Layanan",
    "addClinicalService": "Tambah Layanan Klinis",
    "tabs": {
      "serviceLines": "Lini Layanan",
      "clinicalServices": "Layanan Klinis"
    },
    "searchLines": "Cari lini layanan...",
    "searchServices": "Cari layanan klinis...",
    "empty": {
      "linesNone": "Belum ada lini layanan yang dikonfigurasi.",
      "linesNoMatch": "Tidak ada lini layanan yang cocok.",
      "servicesNone": "Belum ada layanan klinis yang dikonfigurasi.",
      "servicesNoMatch": "Tidak ada layanan klinis yang cocok."
    },
    "columns": {
      "name": "Nama",
      "code": "Kode",
      "description": "Deskripsi",
      "services": "Layanan",
      "status": "Status",
      "serviceLine": "Lini Layanan",
      "specialty": "Spesialisasi",
      "actions": "Tindakan"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "editTitle": "Edit"
  },
  "systemStatus": {
    "connected": "Terhubung",
    "error": "Kesalahan"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} petugas",
      "unstaffedBadge": "tanpa petugas",
      "unstaffedWarning": "Peran berikut tidak memiliki petugas sehingga tingkat tersebut tidak akan memanggil siapa pun: {{roles}}. Tetapkan peran kepada staf di Admin → Pengguna."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
